import React, { useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const Logout = () => {
    useEffect(() => {
        const handleLogout = async () => {
            const token = localStorage.getItem('token'); // For backward compatibility
            
            try {
                await axios.post(`${API_BASE_URL}/logout/`, {}, {
                    headers: {
                        // Keep Authorization header for backward compatibility
                        'Authorization': token ? `Token ${token}` : ''
                    },
                    withCredentials: true // Include cookies in the request
                });
                // console.log(response.data.message);
            } catch (error) {
                // console.log(error.response?.data?.error || 'Logout error');
                console.error('Logout error:', error);
            }

            // Clear localStorage regardless of response
            localStorage.removeItem('token'); // For backward compatibility
            localStorage.removeItem('username');
            
            // Dispatch event to update UI
            window.dispatchEvent(new Event('loginStatusChanged'));
            
            window.location.href = '/';
        };

        handleLogout();
    }, []);

    return (
        <></>
    );
};

export default Logout;
